import React, {useState} from 'react';
import {Badge, Card, CardActionArea, IconButton, Stack, Typography} from '@mui/material';

import {DocumentInfo, filesService} from '@store/files';

import {Close, File} from '@icons/index';
import {Colors} from '@constants/colors.constants';
import ImageModal from '@components/modal/Image.modal';

interface FilesCardProps {
    document: DocumentInfo;
    handleDeleteDocument?: () => void;
    disableOnClick?: boolean;
}

const FilesCard = (props: FilesCardProps) => {
    const {document, handleDeleteDocument, disableOnClick} = props;

    const [preview, setPreview] = useState(false);

    const documentUrl = document.file ? URL.createObjectURL(document.file) : filesService.getDocumentUrl(document.id);

    return (
        <>
            <Badge
                componentsProps={{badge: {style: {right: 4, top: 4}}}}
                invisible={!handleDeleteDocument}
                badgeContent={(
                    <IconButton onClick={handleDeleteDocument} aria-label="remove-document">
                        <Close style={{color: Colors.white, height: 8, width: 8}}/>
                    </IconButton>
                )}>
                <Card
                    variant="document"
                    color="secondary"
                    component={CardActionArea}
                    onClick={() => setPreview(!disableOnClick)}>
                    {document.mimetype.includes('image/') ? (
                        <img
                            alt={''}
                            style={{maxHeight: '100%', maxWidth: '100%'}}
                            src={documentUrl}/>
                    ) : (
                        <>
                            <File/>
                            <Stack mt="5px">
                                <Typography
                                    textAlign="center"
                                    fontSize={10}
                                    fontWeight="700"
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: '2',
                                        WebkitBoxOrient: 'vertical',
                                    }}>
                                    {document.name}
                                </Typography>
                            </Stack>
                        </>
                    )}
                </Card>
            </Badge>
            {preview && (
                <ImageModal
                    imageUrl={documentUrl}
                    onClose={() => setPreview(false)}
                />
            )}
        </>
    );
};

export default FilesCard;
